import {ApiClientFactory, ApiClientFactoryInterface} from "./clients";
import {Headers} from "../types";
import {AutoInvestmentSettingsManager} from "../AutoInvestmentSettingsManager";

export class AutoInvestmentSettingsManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/autoinvest`
    );
  }

  public createAutoInvestmentManager(token: string): AutoInvestmentSettingsManager {
    return new AutoInvestmentSettingsManager(this.apiClientFactory.createAuthorizedClient(token));
  }
}